import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import NextButtonWrapper from '../views-components/NextButtonWrapper';
import { SignupDataInput } from './SignupDataInput';
import { useSignupData } from './useSignupData';
export const SignupDataInputForm = /*#__PURE__*/forwardRef(({
  button,
  dataKey,
  disabled,
  nextButtonEnabled,
  customValidationError,
  shouldShowPlaceholder,
  renderExtraContent = () => null,
  renderExtraIcons,
  submit,
  type,
  buttonProps,
  help
}, ref) => {
  const {
    isValid
  } = useSignupData(dataKey);

  const onSubmit = () => {
    const isReadyToSubmit = isValid && submit || nextButtonEnabled;

    if (isReadyToSubmit) {
      submit();
    }
  };

  return /*#__PURE__*/_jsxs("form", {
    action: "blue-button-in-all-fields-ios",
    onSubmit: onSubmit,
    children: [/*#__PURE__*/_jsx(SignupDataInput, {
      customValidationError: customValidationError,
      dataKey: dataKey,
      disabled: disabled,
      help: help,
      ref: ref,
      renderExtraIcons: renderExtraIcons,
      shouldShowPlaceholder: shouldShowPlaceholder,
      type: type
    }), renderExtraContent(), !button ? /*#__PURE__*/_jsx(NextButtonWrapper, Object.assign({
      enabled: nextButtonEnabled,
      onClick: onSubmit
    }, buttonProps)) : button]
  });
});